import React, { useEffect, useState } from "react";
import { Tab } from "react-bootstrap";
import { Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "../../Profile/companyProfile.css";
import editProfileService from "../../../components/Services/editProfile.service";
import MyDocuments from "../../Documents/myDocuments";
import analystService from "../../../components/Services/analyst.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";
import GnaRegistration from "./gnaRegistration";
import CapacityListingHeader from "../../Profile/capacityListingNew/capacityListingHeader";
import CapacityListingByUser from "./capacityListingByUser";
import NodataFound from "../../../commons/Toast/noDataFound";
import { GeneratorCapacityModal } from "./generatorCapacityModal";
import { useDispatch, useSelector } from "react-redux";
import { ConsumerCapacityModal } from "./consumerCapacityModal";
import Logs from "../../Profile/capacityListingNew/logs";
import logsService from "../../../components/Services/logs.service";
import { CircularProgress } from "@mui/material";
import { Card } from "react-bootstrap";
import Styles from "../../../Styles/TraderDashboard/Trader.module.css";
import { BankingSlot } from "../../Auth/Banking/bankingSlot";
import Trader from "../../Profile/Trader/Trader";
import { getAllTraders, getSpeceficTraders } from "../../../store/Analyst/action";

const ViewUserProfile = () => {
  const dispatch = useDispatch();
 let userDetails = JSON.parse(localStorage.getItem("UserDetails"));

 const [myProfileDetails, setMyProfileDetails] = useState(null);
 const [isEditProfile, setIsEditProfile] = useState(false);
 const [isLoader, setIsLoader] = useState(true);
 const [capacityList, setCapacityList] = useState(null);
 const [key, setKey] = useState("Details1");
 const [logsList, setLogsList] = useState(null);
 const [active, setActive] = useState(
  userDetails?.accountTypes?.length > 1
   ? "CONSUMER"
   : userDetails?.accountTypes?.[0]
 );
 const [editType,setEditType] = useState("")
 const compId = myProfileDetails?.companyResponse?.plant?.company?.id || myProfileDetails?.companyResponse?.consumer?.company?.id || myProfileDetails?.companyResponse?.id;

 const handleSelect = (key) => {
  setKey(key);
 };
 const getMyProfileDetails = (id) => {
  editProfileService
   .getMyProfileDetails(id)
   .then((response) => {
    if (response?.data?.code === 200) {
     setMyProfileDetails(response?.data?.data);
     setIsLoader(false);
    } else {
     setMyProfileDetails(null);
     setIsLoader(false);
    }
   })
   .catch((err) => {
    console.log("Api Call Err", err);
    setMyProfileDetails(null);
    setIsLoader(false);
   });
 };

 const handleAccountStatus = (accStatus) => {
  analystService
   .updateAccountStatus(accStatus, userDetails?.companyId)
   .then((response) => {
    if (response?.data?.code === 200) {
     toast.success(response?.data?.message, toastProperties);
     getMyProfileDetails(userDetails?.userId);
    }
   })
   .catch((error) => console.error("Api call Error:", error));
 };

 const handleOpenEditProfileModal = () => {
  setIsEditProfile(true);
 };

 const handleCloseEditProfileModal = () => {
  setIsEditProfile(false);
 };

 const handleCapacityListing = (key) => {
  if (key === "CapacityListing") {
   setCapacityList(null);
   if (active === "GENERATOR") {
    analystService
     .getAllCapacityListingByPlantId(
      myProfileDetails?.companyResponse?.plant?.id
     )
     .then((response) => {
      if (response?.data?.code === 200) {
       setCapacityList(response?.data?.data);
      }
     })
     .catch((error) => console.error("Api call Error:", error));
   }
   if (active === "CONSUMER") {
    analystService
     .getAllCapacityListingByConsumerId(
      myProfileDetails?.companyResponse?.consumer?.id
     )
     .then((response) => {
      if (response?.data?.code === 200) {
       setCapacityList(response?.data?.data);
      }
     })
     .catch((error) => console.error("Api call Error:", error));
   }
   if (active === "BANKING") {
    analystService
     .getAllCapacityListingByBankId(
      myProfileDetails?.companyResponse?.id
     )
     .then((response) => {
      if (response?.data?.code === 200) {
        setEditType("discom")
        setCapacityList(response?.data?.data);
      }
     })
     .catch((error) => console.error("Api call Error:", error));
   }
  }
 };
 const getLogsLIst = () => {
  logsService
   .getLogsList(userDetails?.userId)
   .then((response) => {
    if (response?.data?.code === 200) {
     setLogsList(response?.data?.data);
    }
   })
   .catch((error) => {
    console.log("Api Error:", error);
   });
 };
 useEffect(() => {
  if (key === "MyLogs") {
   getLogsLIst();
  } else {
   handleCapacityListing(key);
  }
 }, [key, active]);

 useEffect(() => {
  getMyProfileDetails(userDetails?.userId);
 }, []);

 useEffect(() => {
  getAllTraders()(dispatch);
  getSpeceficTraders(userDetails?.companyId)(dispatch);
}, []);
 const configKey = useSelector((state) => state?.sessionState?.connectionName);
 const [isModel, setIsModel] = useState(false);

 const handleEditClick = (item) => {
  setIsModel(item);
 };
 const handleAddNewSlot = (e) => {
    setIsModel(true);
 };
 const handleChangeType = (data) => {
  if (active !== data) {
   setActive(data);
  } else {
   return;
  }
 };
 console.log(myProfileDetails);
 return (
  <>
   {isModel && active !== "BANKING" &&
    (active === "GENERATOR" ? (
     <GeneratorCapacityModal
      isOpen={isModel}
      handleSubmit={handleEditClick}
      myProfileDetails={myProfileDetails}
      handleCapacityListing={handleCapacityListing}
     />
    ) : (
     <ConsumerCapacityModal
      isOpen={isModel}
      handleSubmit={handleEditClick}
      myProfileDetails={myProfileDetails}
      handleCapacityListing={handleCapacityListing}
     />
    ))}
    {
     isModel && active === "BANKING" && (
        <BankingSlot isOpen={isModel} handleSubmit={handleEditClick} compId={compId}  />
      )
    }

   {isEditProfile && (
    <Modal
     show={isEditProfile}
     onHide={handleCloseEditProfileModal}
     dialogClassName="my-modal"
     centered
    >
     <Modal.Header closeButton>
      <Modal.Title>Edit Profile</Modal.Title>
     </Modal.Header>
     <Modal.Body className="m-3 table-scrollY">
      <GnaRegistration
       getMyProfileDetails={getMyProfileDetails}
       handleCloseEditProfileModal={handleCloseEditProfileModal}
       myProfileDetails={myProfileDetails}
      />
     </Modal.Body>
    </Modal>
   )}
   {isLoader ? (
        <div className="popup-background">
         <CircularProgress />
        </div>
       ) : <div className="container my-4">
    <Link to={"/analyst_dashboard"}>
     <button className="btn btn-secondary mb-3">
      <i className="fa fa-chevron-left"></i> Back to Dashboard
     </button>
    </Link>
    <div className="capacity-card mb-3">
     <div className="capacity-card-body">
      <div className="company-profile-details-wrap">
       <div className="company-profile-rside w-75">
        <h4 className="company-profile-title">
         {myProfileDetails?.companyResponse?.name}
        </h4>
        <div className="company-profile-descprition">
         {myProfileDetails?.companyResponse?.description}
        </div>
        <div className="company-profile-gst">
         <div>GSTIN -{myProfileDetails?.companyResponse?.gst}</div>
         <div>TAN - {myProfileDetails?.companyResponse?.tan}</div>
         <div>PAN - {myProfileDetails?.companyResponse?.pan}</div>
         <br />
         <br />
        </div>
       </div>
      </div>
     </div>
    </div>
    <div className="company-profile-btn-group justify-content-end my-4">
     <button
      type="button"
      className="btn btn-login"
      onClick={handleOpenEditProfileModal}
     >
      Edit Profile
     </button>
     <button
      type="button"
      className="btn btn-login"
      disabled={myProfileDetails?.companyResponse?.accountStatus === "VERIFIED"}
      onClick={() => {
       handleAccountStatus("VERIFIED");
      }}
     >
      Verify
     </button>
     <button
      type="button"
      className="btn btn-login"
      disabled={myProfileDetails?.companyResponse?.accountStatus === "REJECTED"}
      onClick={() => {
       handleAccountStatus("REJECTED");
      }}
     >
      Reject
     </button>
     <button
      type="button"
      className="btn btn-bookmark"
      disabled={myProfileDetails?.companyResponse?.accountStatus === "HOLD"}
      onClick={() => {
       handleAccountStatus("HOLD");
      }}
     >
      Hold
     </button>
     <button
      type="button"
      disabled={key !== "CapacityListing"}
      className="btn btn-login"
      onClick={handleAddNewSlot}
     >
      Add New {active === "BANKING" ? "Banking" : "Capacity"}
     </button>
    </div>
    <div className="capacity-card">
     <div className="capacity-card-body">
      <div className="setting-section-nev">
       {!isLoader && myProfileDetails ? (
        <Tabs
         variant="nav"
         defaultActiveKey="Details1"
         id="company-profile-tab"
         onSelect={(e) => handleSelect(e)}
        >
         <Tab eventKey="Details1" title="Company Information">
          <div className="compnay_tab_flex">
           <div className="div-table" style={{ marginRight: "20%" }}>
            <div className="div-row">
             <div className="div-cell">Member ID</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
                             {myProfileDetails?.userResponse?.memberId}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">User Name</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.userResponse?.userName}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Email</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.userResponse?.email}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Phone Number</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.userResponse?.phone}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Credit Rating</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.creditRating?.rating}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Credit Rating Year</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.creditRatingYear}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Credit Rating Agency</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.creditRatingAgency}
             </div>
            </div>
            <div className="div-cell div-cell-black">Bank Details</div>
            <div className="div-row">
             <div className="div-cell">Name and Branch Address</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.bankAccounts[0]?.name}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Account Number</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.bankAccounts[0]?.accNo}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Ifsc Code</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.bankAccounts[0]?.ifsc}
             </div>
            </div>
           </div>
           <div className="div-table">
            <div className="div-cell div-cell-black">Office Address</div>
            <div className="div-row">
             <div className="div-cell">Registered Address</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.address}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">State</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.stateUt}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">City</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.city}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Pin Code</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.pin}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Telephone</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.tel}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Email</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.email}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Fax Number</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.fax}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Name Of Contact Person(s)</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.contactPersons?.join(
               ", "
              )}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Mobile Number</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[0]?.mob}
             </div>
            </div>
            <div className="div-cell div-cell-black">
             Correspondence Address
            </div>
            <div className="div-row">
             <div className="div-cell">Address</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.address}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">State</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.stateUt}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">City</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.city}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Pin Code</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.pin}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Telephone</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.tel}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Email</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.email}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Fax Number</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.fax}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Name Of Contact Person(s)</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.contactPersons?.join(
               ", "
              )}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Mobile Number</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.addresses[1]?.mob}
             </div>
            </div>
           </div>
          </div>
         </Tab>
         {myProfileDetails?.companyResponse?.plant && (
          <Tab eventKey="Details2" title={"Plant Details"}>
           <div className="compnay_tab_flex">
            <div className="div-table" style={{ marginRight: "20%" }}>
             <div className="div-row">
              <div className="div-cell">Generating Type</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.energyType?.genType}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">Energy Type</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.energyType?.type}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">Plant Specification</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">{myProfileDetails?.companyResponse?.plant?.specification?.name}</div>
             </div>
             <div className="div-row">
              <div className="div-cell">Project Id</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.projectId}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">Install Capacity</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.installedCap
                ? myProfileDetails?.companyResponse?.plant?.installedCap
                : "NA"}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">Control Area</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.controlArea?.type}
              </div>
             </div>
            </div>
            <div className="div-table">
             <div className="div-row">
              <div className="div-cell">Point Of Injection</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.poi?.value}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">Poi Location</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.poiLocation}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">Region</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.region}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">State</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.stateUt}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">Discom</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.discom?.acronym}
              </div>
             </div>
             <div className="div-row">
              <div className="div-cell">Voltage Level at Discom</div>
              <div className="div-cell">:</div>
              <div className="div-cell div-cell-black">
               {myProfileDetails?.companyResponse?.plant?.discomVoltage}
              </div>
             </div>
            </div>
           </div>
          </Tab>
         )}
         {myProfileDetails?.companyResponse?.consumer && (
          <Tab eventKey="Details3" title={"Consumer Details"}>
           <div className="div-table">
            <div className="div-row">
             <div className="div-cell">Maximum Capacity Of Drawal</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.consumer?.maxCapDrawl
               ? myProfileDetails?.companyResponse?.consumer?.maxCapDrawl
               : "NA"}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Region</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.consumer?.region
               ? myProfileDetails?.companyResponse?.consumer?.region
               : "NA"}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">State</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.consumer?.stateUt
               ? myProfileDetails?.companyResponse?.consumer?.stateUt
               : "NA"}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Point of Drawal</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.consumer?.pod?.value
               ? myProfileDetails?.companyResponse?.consumer?.pod?.value
               : "NA"}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Consumer Specification</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.consumer?.specification?.name
               ? myProfileDetails?.companyResponse?.consumer?.specification
                  ?.name
               : "NA"}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Discom</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.consumer?.discom?.discom
               ? myProfileDetails?.companyResponse?.consumer?.discom?.discom
               : "NA"}
             </div>
            </div>
            <div className="div-row">
             <div className="div-cell">Discom Voltage Level</div>
             <div className="div-cell">:</div>
             <div className="div-cell div-cell-black">
              {myProfileDetails?.companyResponse?.consumer?.discomVoltage}
             </div>
            </div>
           </div>
          </Tab>
         )}
         <Tab eventKey="Details4" title={"Documents"}>
          <MyDocuments />
         </Tab>
         <Tab
          eventKey={"CapacityListing"}
          title="Capacity Listing"
          className="table-scrollY"
         >
          <div className={Styles.traderMainContainer}>
           {userDetails?.accountTypes?.length > 1 && (
            <div className={Styles.tradeHeading}>
             <div className={Styles.alterContainer}>
              <div
               onClick={() => handleChangeType("CONSUMER")}
               className={
                active === "CONSUMER" ? Styles.activeConsumerRole : ""
               }
              >
               Consumer
              </div>
              <div
               onClick={() => handleChangeType("GENERATOR")}
               className={
                active === "GENERATOR" ? Styles.activeGeneratorRole : ""
               }
              >
               Generator
              </div>
              <div
               onClick={() => handleChangeType("BANKING")}
               className={
                active === "BANKING" ? Styles.activeGeneratorRole : ""
               }
              >
               Banking
              </div>
             </div>
            </div>
           )}
           <div
            className={Styles.listingSections}
            style={{ marginBottom: "10px" }}
           >
            {capacityList?.length > 0 ? (
             capacityList?.map((item, i) => (
              <div key={i} className="mb-4 cus-border">
               <div style={{width:"100%"}} className="bids-name-wrap bids-name-wrap-header">
                <CapacityListingByUser
                 item={item}
                 myProfileDetails={myProfileDetails}
                 handleCapacityListing={handleCapacityListing}
                 active={active}
                />
               </div>
              </div>
             ))
            ) : (
             <NodataFound />
            )}
           </div>
          </div>
         </Tab>
         <Tab eventKey={"MyLogs"} title="User Logs" className="table-scrollY">
          {logsList?.length > 0 ? (
           <Logs logsList={logsList} userDetails={userDetails} />
          ) : (
           <div className="text-center">
            <CircularProgress />
           </div>
          )}
         </Tab>
         {
          active !== "BANKING" && (
          <Tab eventKey={"TraderSelection"} title="Trader" className="table-scrollY">
            <Trader userDetails={userDetails}/>
          </Tab>
          )
         }
        </Tabs>
       ) : (
        <NodataFound />
       )}
      </div>
     </div>
    </div>
   </div>}
  </>
 );
};

export default ViewUserProfile;
